import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Stepper from './stepper';
import Form from './form';
import { submitBusinessDetails } from '../../redux/authentication/actionCreator';
import './step.css';

const BusinessForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { tempData } = useSelector((state) => state.user);

    const [formData, setFormData] = useState({
        step: 0,
        name: '',
        website: '',
        services: [],
        location: '',
        images: [],
    });

    const steps = [
        'Business Name',
        'Services you offer',
        'Set Location',
        'Upload Photos',
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleNext = () => {
        setFormData((prevData) => ({
            ...prevData,
            step: prevData.step + 1,
        }));
    };

    const handlePrev = () => {
        setFormData((prevData) => ({
            ...prevData,
            step: prevData.step - 1,
        }));
    };

    const submitBusinessForm = () => {
        const payload = new FormData();
        payload.append('name', formData.name);
        payload.append('website', formData.website);
        payload.append('latitude', formData.latitude);
        payload.append('longitude', formData.longitude);
        payload.append('address', formData.address);
        payload.append('user_id', tempData?.user_id || '');

        formData?.images.forEach((image) => {
            payload.append('images', image);
        });
        formData?.services.forEach((item, index) => {
            payload.append(`categories[${index}]`, item);
        });

        dispatch(submitBusinessDetails(payload, history, tempData, () => {
            history.push('/pricing-plan');
        })).catch((err) => {
            console.error('Failed to submit business details:', err);
        });
    };

    useEffect(() => {
        if (window.location.pathname.includes('upload-from-instagram')) {
            const storedFormData = JSON.parse(localStorage.getItem('formData'));
            if (storedFormData) {
                setFormData(storedFormData);
            }
        }
    }, []);

    return (
        <div>
            <Stepper steps={steps} currentStep={formData.step} />
            <Form
                setFormData={setFormData}
                formData={formData}
                handleChange={handleChange}
                handleNext={handleNext}
                handlePrev={handlePrev}
                onSubmit={submitBusinessForm}
            />
        </div>
    );
};

export default BusinessForm;
